export default "__VITE_ASSET__adcffbb3__"